<template>
  <div class="shop-sign-in-page">
    <el-card v-loading="loading">
      <Accordion :shops="shops"
                 @shopConnexion="getJWT($event)"></Accordion>
    </el-card>
  </div>
</template>

<script>
  import services from 'services';
  import UserProfile from '../../entities/UserProfile';
  import Accordion from '../../components/Mgmt/Accordion.vue';

  export default {
    components: {
      Accordion,
    },
    data() {
      return {
        shops: {},
        loading: true,
      };
    },
    props: {
      email: {
        type: String,
        required: true,
      },
    },
    async mounted() {
      await services.ADService.getShopsByMgmt(this.email)
        .then(
          (data) => {
            this.loading = false;
            this.shops = data;
          },
        );
    },
    methods: {
      async getJWT(shopInfo) {
        this.loading = true;
        const jwt = await services.ShopAuthService.getShopJWT(shopInfo);
        await this.$store.dispatch('shopAuth/handleMagicLinkToken', jwt);
        const userProfile = this.getInfos(shopInfo.id);
        const userCreated = await services
          .AuthService
          .createShopUser(userProfile, '12345678', shopInfo.id);
        try {
          await this.$store.dispatch('auth/loginWithCredentials', {
            username: userCreated.email,
            password: '12345678',
          });
          await this.$store.dispatch('auth/updateUser', {
            user: userCreated,
          });
          this.$mixpanel.track('Connexion utilisateur', {
            app_mb: process.env.VUE_APP_NAME,
            email: userCreated.email,
          });
          await this.$router.push({ name: 'Dashboard' });
          this.showSuccessMessage();
        } catch (e) {
          console.log(e);
          // this.showErrorMessage();
        }
      },
      getInfos(shopId) {
        return new UserProfile({
          firstname: 'Responsable',
          lastname: 'Regional',
          role: 'RESPONSABLE_MAGASIN',
          status: 'active',
          shopId: shopId.toString(),
        });
      },
      showSuccessMessage() {
        this.$message({
          type: 'success',
          message: `${this.$t('loginPage.successMessage')} ${this.$store.getters['auth/currentUser'].user.name}!`,
        });
      },
      showErrorMessage() {
        this.$message({
          type: 'error',
          message: this.$t('commons.defaultErrorMessage'),
        });
      },
    },
  };
</script>

<style lang="stylus">
  .shop-sign-in-page {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .card--center {
    margin auto auto
  }
</style>
